import { SEARCH_ARTICLES } from "constants/actionTypes";
import KeywordSourceV2 from "modules/Campaigns/CampaignAssets/Components/KeywordSourceV2";
import Button from "modules/Common/Components/Button";
import ButtonOutlineTwo from "modules/Common/Components/ButtonOutlineTwo";
import ButtonRightIcon from "modules/Common/Components/ButtonRightIcon";
import ButtonRightIconGreen from "modules/Common/Components/ButtonRightIconGreen";
import ConfirmDialog from "modules/Common/Components/ConfirmDialog";
import { closeOverlay, GLOBAL_ACTION } from "modules/GlobalActions";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import store, { RootState } from "store";
import { Tooltip, Popover } from "antd";
import styled from "styled-components";
import ExcludeContent from "./ExcludeContent";
import IncludeContent from "./IncludeContent";
import Info from "../../../assets/img/icons/Info.svg";

interface IAdvancedSearch {
  inCampaignSmartSourced?: boolean;
}

const AdvancedSearch: React.FC<IAdvancedSearch> = ({ inCampaignSmartSourced }) => {
  const [excludedKeywords, setExcludedKeywords] = useState<string[]>([]);
  const [includedKeywords, setIncludedKeywords] = useState<string[]>([]);
  const [showConfirm, setShowConfirm] = useState(false);
  const [showConfirmInclude, setShowConfirmInclude] = useState(false);
  const [errorIncludedKeywords, setErrorIncludedKeywords] = useState<boolean>(false);
  const [errorExcludedKeywords, setErrorExcludedKeywords] = useState<boolean>(false);
  const [errorMsgIncludedKeywords, setErrorMsgIncludedKeywords] = useState<string>("Invalid entry");
  const [errorMsgExcludedKeywords, setErrorMsgExcludedKeywords] = useState<string>("Invalid entry");
  const [errorMsgIncludedKeywordsEmpty, setErrorMsgIncludedKeywordsEmpty] = useState<boolean>(false);

  const excludedKeywordsReducer = useSelector((state: RootState) => state.assets.excludeKeywords);
  const includedKeywordsReducer = useSelector((state: RootState) => state.assets.includeKeywords);
  const advancedSearch = useSelector((state: RootState) => state.uiReducer.advancedSearch);

  const [afterFirstMount, setAfterFirstMount] = useState(false);

  useEffect(() => {
    if (
      !window.location.pathname.startsWith("/content/search") &&
      includedKeywords.length === 0 &&
      afterFirstMount
    ) {
      setErrorMsgIncludedKeywordsEmpty(true);
      setTimeout(() => {
        setErrorMsgIncludedKeywordsEmpty(false);
      }, 3000);
    } else if (!afterFirstMount) {
      setAfterFirstMount(true);
    }
  }, [advancedSearch]);

  useEffect(() => {
    // if (excludedKeywordsReducer.length > 0) {
    setExcludedKeywords(excludedKeywordsReducer);
    store.dispatch({
      type: SEARCH_ARTICLES.EXCLUDE_KEYWORDS,
      payload: excludedKeywordsReducer,
    });
    // }
    // if (includedKeywordsReducer.length > 0) {
    setIncludedKeywords(includedKeywordsReducer);
    store.dispatch({
      type: SEARCH_ARTICLES.INCLUDED_KEYWORDS,
      payload: includedKeywordsReducer,
    });
    // }
  }, [excludedKeywordsReducer, includedKeywordsReducer]);

  const showAdvancedSearchSidebar: boolean = useSelector(
    (state: RootState) => state.uiReducer.showAdvancedSearchSidebar
  );

  const handleErrorIncludedKeywords = (msg?: string) => {
    setErrorIncludedKeywords(true);
    setErrorMsgIncludedKeywords(msg ? msg : "Invalid entry");
    setTimeout(() => {
      setErrorIncludedKeywords(false);
    }, 3000);
  };

  const handleErrorExcludedKeywords = (msg?: string) => {
    setErrorExcludedKeywords(true);
    setErrorMsgExcludedKeywords(msg ? msg : "Invalid entry");
    setTimeout(() => {
      setErrorExcludedKeywords(false);
    }, 3000);
  };

  const handleAddKeywordToExclude = (value: string) => {
    if (value.includes(",")) {
      let valueAlreadyPresentInIncludedKeywords = true;
      const currentSearchTerms = value
        .toLowerCase()
        .trim()
        .split(",")
        .filter((r) => r !== "")
        .map((r) => r.trim().toLowerCase().replace(" and ", " AND "));
      const trimmedTerms = currentSearchTerms.map((r) => r.trim());
      let dupSearchTerms = excludedKeywords;
      currentSearchTerms.map((term) => {
        if (dupSearchTerms.indexOf(term.trim()) === -1 && includedKeywords.indexOf(term.trim()) === -1) {
          if (term.trim() !== "") {
            dupSearchTerms.push(term.trim());
            valueAlreadyPresentInIncludedKeywords = false;
          }
          setExcludedKeywords([...dupSearchTerms.map((r) => r.trim().toLowerCase().replace(" and ", " AND "))]);
        }
      });
      const val = JSON.stringify(trimmedTerms) === JSON.stringify(excludedKeywords);
      if (valueAlreadyPresentInIncludedKeywords && !val) {
        handleErrorExcludedKeywords("already added in included keywords");
      }

      store.dispatch({
        type: SEARCH_ARTICLES.EXCLUDE_KEYWORDS,
        payload: dupSearchTerms,
      });
      return;
    }
    if (includedKeywords.indexOf(value.trim().toLowerCase().replace(" and ", " AND ")) === -1) {
      const newExcludedKeywords = [...excludedKeywords, value.trim().toLowerCase()];
      const newExcludedKeywordsUnique = [...new Set(newExcludedKeywords)].map((r) =>
        r.trim().toLowerCase().replace(" and ", " AND ")
      );
      setExcludedKeywords(newExcludedKeywordsUnique);
      store.dispatch({
        type: SEARCH_ARTICLES.EXCLUDE_KEYWORDS,
        payload: newExcludedKeywordsUnique,
      });
    } else {
      handleErrorExcludedKeywords("already added in included keywords");
    }
  };

  const handleAddKeywordToInclude = (value: string) => {
    if (value.includes(",")) {
      let valueAlreadyPresentInExcludedKeywords = true;
      const currentSearchTerms = value
        .toLowerCase()
        .trim()
        .split(",")
        .filter((r) => r !== "")
        .map((r) => r.trim().toLowerCase().replace(" and ", " AND "));
      const trimmedTerms = currentSearchTerms.map((r) => r.trim());
      let dupSearchTerms = includedKeywords;
      currentSearchTerms.map((term) => {
        if (dupSearchTerms.indexOf(term.trim()) === -1 && excludedKeywords.indexOf(term.trim()) === -1) {
          if (term.trim() !== "") {
            dupSearchTerms.push(term.trim());
            valueAlreadyPresentInExcludedKeywords = false;
          }
          setIncludedKeywords([...dupSearchTerms.map((r) => r.trim().toLowerCase().replace(" and ", " AND "))]);
        }
      });
      const val = JSON.stringify(trimmedTerms) === JSON.stringify(includedKeywords);
      if (valueAlreadyPresentInExcludedKeywords && !val)
        handleErrorIncludedKeywords("already added in excluded keywords");
      store.dispatch({
        type: SEARCH_ARTICLES.INCLUDED_KEYWORDS,
        payload: dupSearchTerms,
      });
      return;
    }
    if (excludedKeywords.indexOf(value.trim().toLowerCase().replace(" and ", " AND ")) === -1) {
      const newIncludeddKeywords = [...includedKeywords, value.trim().toLowerCase().replace(" and ", " AND ")];
      const newIncludeddKeywordsUnique = [...new Set(newIncludeddKeywords)].map((r) =>
        r.trim().toLowerCase().replace(" and ", " AND ")
      );
      setIncludedKeywords(newIncludeddKeywordsUnique);
      store.dispatch({
        type: SEARCH_ARTICLES.INCLUDED_KEYWORDS,
        payload: newIncludeddKeywordsUnique,
      });
    } else {
      handleErrorIncludedKeywords("already added in excluded keywords");
    }
  };

  const handleOnRemoveKeywordToExclude = (value: string) => {
    const newExcludedKeywords = excludedKeywords.filter((keyword) => keyword !== value);
    setExcludedKeywords(newExcludedKeywords);
    store.dispatch({
      type: SEARCH_ARTICLES.EXCLUDE_KEYWORDS,
      payload: newExcludedKeywords,
    });
  };

  const handleOnRemoveKeywordToInclude = (value: string) => {
    const newIncludedKeywords = includedKeywords.filter((keyword) => keyword !== value);
    setIncludedKeywords(newIncludedKeywords);
    store.dispatch({
      type: SEARCH_ARTICLES.INCLUDED_KEYWORDS,
      payload: newIncludedKeywords,
    });
  };

  const deleteAllKeywordsHandler = () => {
    if (excludedKeywords.length > 0) setShowConfirm(true);
  };

  const deleteAllIncludedKeywordsHandler = () => {
    if (includedKeywords.length > 0) setShowConfirmInclude(true);
  };

  const handleConfirmDeleteAllKeywords = () => {
    setExcludedKeywords([]);
    setShowConfirm(false);
    store.dispatch({
      type: SEARCH_ARTICLES.EXCLUDE_KEYWORDS,
      payload: [],
    });
  };

  const handleConfirmDeleteAllIncludedKeywords = () => {
    setIncludedKeywords([]);
    setShowConfirmInclude(false);
    store.dispatch({
      type: SEARCH_ARTICLES.INCLUDED_KEYWORDS,
      payload: [],
    });
  };

  const handleCancelDeleteAllKeywords = () => {
    setShowConfirm(false);
  };

  const handleCancelDeleteAllIncludedKeywords = () => {
    setShowConfirmInclude(false);
  };

  return (
    <Wrapper className="advance-search">
      <div className="heading-main">
        <p>Advanced search</p>
        <span className="search-info">
          <Popover
            placement="leftTop"
            overlayClassName="info-tooltip"
            content="Exclude or include Keywords, Websites, Twitter handles, and RSS feeds as sources to refine your search."
            getPopupContainer={() => document.querySelectorAll(".advance-search")[0] as HTMLElement}
          >
            <img src={Info} alt="info-icon" />
          </Popover>
        </span>
      </div>
      {inCampaignSmartSourced && (
        <KeywordSourceV2
          errorMsgIncludedKeywordsEmpty={errorMsgIncludedKeywordsEmpty}
          errorIncludedKeywords={errorIncludedKeywords}
          errorMsgIncludedKeywords={errorMsgIncludedKeywords}
          inAdvancedSearch={true}
          heading="Keywords to include:"
          // subText="optional"
          desClassName={includedKeywords && includedKeywords?.length > 0 ? "mb-s" : ""}
          placeholder={includedKeywords && includedKeywords?.length > 0 ? "" : "Keywords to include in content"}
          desc=""
          searchTerms={includedKeywords}
          handleAddSearchTerm={(value: string) => handleAddKeywordToInclude(value)}
          handleOnRemove={(value: string) => handleOnRemoveKeywordToInclude(value)}
          deleteAllKeywordsHandler={deleteAllIncludedKeywordsHandler}
          includedKeywords={true}
          idprefix="advance-search-include"
        ></KeywordSourceV2>
      )}
      <KeywordSourceV2
        errorExcludedKeywords={errorExcludedKeywords}
        errorMsgExcludedKeywords={errorMsgExcludedKeywords}
        inAdvancedSearch={true}
        heading="Keywords to exclude:"
        // subText="optional"
        desClassName={excludedKeywords && excludedKeywords?.length > 0 ? "mb-s" : ""}
        placeholder={excludedKeywords && excludedKeywords?.length > 0 ? "" : "Keywords to exclude from content"}
        desc=""
        searchTerms={excludedKeywords}
        handleAddSearchTerm={(value: string) => handleAddKeywordToExclude(value)}
        handleOnRemove={(value: string) => handleOnRemoveKeywordToExclude(value)}
        deleteAllKeywordsHandler={deleteAllKeywordsHandler}
        excludedKeywords={true}
        idprefix="advance-search-exclude"
      ></KeywordSourceV2>
      <IncludeContent />
      <ExcludeContent />

      {showConfirmInclude && (
        <ConfirmDialog
          inAdvancedSearch={true}
          confirm="Yes"
          cancel="No"
          onConfirm={handleConfirmDeleteAllIncludedKeywords}
          onCancel={handleCancelDeleteAllIncludedKeywords}
          title="Current included keywords will be removed."
          titleQuestion="Are you sure?"
        />
      )}

      {showConfirm && (
        <ConfirmDialog
          inAdvancedSearch={true}
          confirm="Yes"
          cancel="No"
          onConfirm={handleConfirmDeleteAllKeywords}
          onCancel={handleCancelDeleteAllKeywords}
          title="Current excluded keywords will be removed."
          titleQuestion="Are you sure?"
        />
      )}
    </Wrapper>
  );
};

export default AdvancedSearch;

const Wrapper = styled.div`
  margin: 30px 15px;
  div > .add-words-wrapper {
    margin-top: 0;
  }
  div > .add-words-wrapper > .dec-paragraph.mb {
    margin-bottom: 0;
  }
  .error-msg-style {
    color: #db3725;
    font-size: 12px;
  }
  .heading-main {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    margin-bottom: 40px;
    p {
      font-weight: 700;
      font-size: 46px;
      color: #424b50;
      line-height: 0.9;
      max-width: 220px;
      margin-bottom: 0;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        font-size: 38px;
      }
    }
    .search-info {
      cursor: pointer;
    }
  }
  .keyword-count {
    color: #7e7e7e;
    font-family: "Roboto Slab";
    font-size: 14px;
    font-weight: 700;
    margin-right: 5px;
  }
  .info-tooltip {
    width: 410px;
    background: transparent;
    border-radius: 15px;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      width: 320px;
    }
    .ant-popover-content {
      .ant-popover-arrow {
        right: 3px;
        top: 5px;
        width: 15px;
        height: 15px;
        border-width: 7px;
      }
      .ant-popover-inner {
        border-radius: 15px;
        .ant-popover-inner-content {
          padding: 20px 24px;
          color: #7e7e7e;
          font-size: 16px;
          font-weight: 500;
          font-family: "Roboto", sans-serif;
          line-height: 24px;
          border-radius: 15px;
          box-shadow: 0px 2px 60px 0 rgba(0, 0, 0, 0.28);
          margin-top: -15px;
          @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
            font-size: 14px;
            line-height: 20px;
          }
        }
      }
    }
  }
`;
